import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762390306366'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='11286'
        width='200'
        height='200'
    >
        <path
            d='M358.914534 359.930043a93.182458 93.182458 0 1 0 186.364915 0 93.182458 93.182458 0 1 0-186.364915 0Z'
            fill='currentColor'
            p-id='11287'
        ></path>
        <path
            d='M569.343051 732.147883m-27.647542 0a27.647542 27.647542 0 1 0 55.295084 0 27.647542 27.647542 0 1 0-55.295084 0Z'
            fill='currentColor'
            p-id='11288'
        ></path>
        <path
            d='M665.597458 636.917459m-27.647542 0a27.647542 27.647542 0 1 0 55.295084 0 27.647542 27.647542 0 1 0-55.295084 0Z'
            fill='currentColor'
            p-id='11289'
        ></path>
        <path
            d='M541.695509 732.147883v-80.38267s-2.047966-42.495297 38.911356-42.495296H665.597458v55.295084h-55.295085s-13.31178-1.535975-13.31178 17.407712v50.17517h-55.295084z'
            fill='currentColor'
            p-id='11290'
        ></path>
        <path
            d='M820.730891 636.405467m-27.647543 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11291'
        ></path>
        <path
            d='M915.961314 732.659874m-27.647542 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11292'
        ></path>
        <path
            d='M820.730891 608.757925H901.11356s42.495297-2.047966 42.495297 38.911356v84.990593h-55.295085v-55.295084s1.535975-13.31178-17.407712-13.31178h-50.175169v-55.295085z'
            fill='currentColor'
            p-id='11293'
        ></path>
        <path
            d='M915.961314 900.593095m-27.647542 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11294'
        ></path>
        <path
            d='M819.194916 995.823519m-27.647543 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11295'
        ></path>
        <path
            d='M943.608857 900.593095v80.38267s2.047966 42.495297-38.911356 42.495297h-84.990594v-55.295085h55.295085s13.31178 1.535975 13.31178-17.407712v-50.17517h55.295085z'
            fill='currentColor'
            p-id='11296'
        ></path>
        <path
            d='M664.573475 996.335511m-27.647543 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11297'
        ></path>
        <path
            d='M569.343051 900.081104m-27.647542 0a27.647542 27.647542 0 1 0 55.295084 0 27.647542 27.647542 0 1 0-55.295084 0Z'
            fill='currentColor'
            p-id='11298'
        ></path>
        <path
            d='M664.573475 1023.983053h-80.38267s-42.495297 2.047966-42.495296-38.911356v-84.990593h55.295084v55.295085s-1.535975 13.31178 17.407712 13.311779h50.17517V1023.983053z'
            fill='currentColor'
            p-id='11299'
        ></path>
        <path
            d='M569.343051 816.114493m-27.647542 0a27.647542 27.647542 0 1 0 55.295084 0 27.647542 27.647542 0 1 0-55.295084 0Z'
            fill='currentColor'
            p-id='11300'
        ></path>
        <path
            d='M915.961314 816.114493m-27.647542 0a27.647542 27.647542 0 1 0 55.295085 0 27.647542 27.647542 0 1 0-55.295085 0Z'
            fill='currentColor'
            p-id='11301'
        ></path>
        <path d='M569.343051 788.466951h346.106272v55.295085h-346.106272z' fill='currentColor' p-id='11302'></path>
        <path
            d='M458.24089 861.681739H221.188813v67.07089H159.237838V1023.983053h299.003052zM648.701738 522.231357l-14.335763-355.322119S643.581822 4.095932 479.744534 4.095932H232.452627s-22.015636 5.119915-34.815424 30.2075c-34.815424 70.654831-67.07089 146.941568-74.238772 159.741357-11.263814 19.96767-13.31178 40.959322-12.799788 56.319067S110.086652 399.353391 110.086652 399.353391s-1.535975 40.959322-16.895721 57.855042c-14.847754 16.89572-18.431695 46.591229-18.431695 73.72678v193.532797s-7.167881 104.446271 114.686102 104.446271h267.771569l0.511991-248.31589H328.707033s-28.159534 3.583941-28.159533-27.135551V196.092755s-5.119915-27.647542 28.159533-27.647543h216.572416s32.255466-7.167881 32.255466 28.159534v325.11462h71.166823zM328.707033 121.341992h-81.918644v509.94356h81.918644v34.303433H214.532923V87.03856h114.17411v34.303432z'
            fill='currentColor'
            p-id='11303'
        ></path>
    </svg>
)

export const MeasurementIcon = props => <Icon component={SVG} {...props} />
